'use strict';

var $ = (typeof window !== "undefined" ? window.jQuery : typeof global !== "undefined" ? global.jQuery : null);

var notify = require('notify');
var triggerCustomEvent = require('trigger-custom-event');

var appDom = require('./app-dom');
var sidePanel = require('./side-panel');
var dataMgr = require('./data-mgr');

var dom;

var downloadImage = function() {

	var downloadUrl = dataMgr.getEventUrl() + "?page=download_image_action&photoId=" + dataMgr.getImageMeta().photoId;


	/*
		Yaooooooo, taking the "direct download" option out of place for now,
		as you can see with the hardcoded "false &&" in the condition below.

		Why? Because Android is acting a damn fool talking about some "download
		failed" and some such garbanzo beans.

		Ain't nobody got time for that.
		https://support.google.com/chrome/thread/15277772?hl=en

		Instead, the else condition below just rolls out our trusty mobile
		side panel and presents the user with a thumbnail of the image which
		he/she can simply press and hold to prompt them to (successfully)
		download on either platform (Android or iOS).

		#BFITZ

		You, yeah you... you reading this. You're a cool mfer.
	*/


	// if Android, trigger download with link injection method
	if (false && appDom.isTouch() && !appDom.isIos()) {

		var $a = $('<a>').attr({
							href: downloadUrl,
							download: downloadUrl,
							target: '_blank'
						});

		$a[0].click();

	}

	else if (appDom.isTouch() || appDom.isIos()) {

		// iOS presents a multitude of problems for file downloads:
			// 1) don't offer direct download "pop-ups" like windows, osx, and android do
			//    since they don't really offer direct file system access on their devices

			// 2) opening links in new tabs programmatically is blocked as a precaution
			//    against unwanted ad pop-ups.

		// there are some very hacky work-arounds to these issues, but for our solution
		// we will present the user with a modal when he tries to download
		// an image on iOS. In the modal we will present a link where he can explicitly
		// click to download the image, rather than programmatically trigger a click
		// (as in the Android version above). This is an extra step, but necessary.

		// on option we considered was relocating directly to the image for download
		// and then allowing the user to press the back button to return to the app
		// this isn't as good because 1) you have no opportunity to present instructions
		// to the user about how to download (with a long press) and 2) safari back
		// button doesn't fire events as expected because of "back forward caching"

		// http://stackoverflow.com/questions/11979156/mobile-safari-back-button
		// http://stackoverflow.com/questions/24524248/forcing-mobile-safari-to-re-evaluate-the-cached-page-when-user-presses-back-butt

		$.ajax({
			type: 'POST',
			dataType: 'JSON',
			url: dataMgr.getEventUrl() + '?page=download_image_modal',
			data: {
				photoId: dataMgr.getImageMeta().photoId
			}
		}).done(function(response){

			sidePanel.open(response.markup, {type: 'download'});

		});

	}

	// else trigger download with relocation method
	else {

		console.log('about to redirect to:');
		console.log(downloadUrl);

		// tried a few other approaches but this seems to be the best approach
		// for desktop based on my testing when considering multiple operating systems
		// and the behavior of pop-up blockers, etc.
		window.location = downloadUrl;

	}

};

var setupPanelEventHandlers = function() {

	dom.downloadCode.on('keypress.download', function(e) {

		if (e.which === 13) {

			e.preventDefault();

			submitDownloadForm();

		}

	});

};

var setupDom = function() {

	// the download module specific dom can't be setup until the modal
	// has opened and rendered its content
	dom = {};
	dom.form = $('.download-form');
	dom.downloadCode = dom.form.find('[name="downloadCode"]');

};

var attemptImageDownload = function(downloadCode, isFormSubmission) {

	console.log('download code: ' + downloadCode);
	console.log('isFormSubmission: ' + isFormSubmission);
	console.log('url: ' + dataMgr.getEventUrl() + '?page=download_image');

	downloadCode = downloadCode || '';

	$.ajax({
		type: 'POST',
		dataType: 'JSON',
		url: dataMgr.getEventUrl() + '?page=download_image',
		data: {
			downloadCode: downloadCode,
			photoId: dataMgr.getImageMeta().photoId,
			isFormSubmission: isFormSubmission
		}
	}).done(function(response) {

		console.log('response!');
		console.log(JSON.stringify(response));

		triggerCustomEvent(response.status.detail, {
			data: {
				response: response
			}
		});

	});

};

var submitDownloadForm = function() {

	attemptImageDownload(dom.downloadCode.val(), true);

};

var addEventHandlers = function() {

	appDom.document.on('slideshow_download_btn_clicked.download', function(e) {

		e.preventDefault();

		attemptImageDownload('', false);

	});


	appDom.document.on('download_form_loaded.download', function(e, data) {

		sidePanel.open(data.response.markup, {type: 'download'});

	});

	appDom.document.on('download_code_invalid.download download_code_not_provided.download', function(e, data) {

		e.preventDefault();

		notify.show({
			target: dom.downloadCode,
			position: 'bottom',
			container: '.download-form',
			msg: data.response.status.msg
		});

	});

	appDom.document.on('download_image.download', function(e) {

		downloadImage();

		sidePanel.close();

	});

	appDom.document.on('attempt_image_download.download', function() {

		attemptImageDownload('', false);

	});

	appDom.document.on('click.download', '.download-form__submit-btn', function(e) {

		e.preventDefault();

		submitDownloadForm();

	});

	appDom.document.on('side_panel_closed.download', function(e, data) {

		if (data.panelType === 'download') {

			destroy();

		}

	});

	appDom.document.on('side_panel_opened.download', function(e, data) {

		console.log('DATA');
		console.log(data);

		if (data.panelType === 'download') {

			setupDom();

			setupPanelEventHandlers();

		}

	});

};

var destroy = function() {

	dom.downloadCode.off('.download');
	dom = null;

};

var init = function() {

	addEventHandlers();

};

module.exports = {
	init: init
};
